import React, { useEffect, useState, useRef } from 'react';
import { Table, Button, Row, Col, Card, CardBody } from 'reactstrap';
import { Delete } from '@mui/icons-material';
import { db } from '../../MY_LOGIN_AND_SIGNUP/db/config';
import { useLocation, useNavigate } from 'react-router-dom';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import firebase from 'firebase';
import Slide from '@mui/material/Slide';
import { Dialog, CircularProgress } from '@mui/material';
import AddQuestionQuiz from './AddQuestionQuiz';
import NotificationAlert from 'react-notification-alert';
const QuizQuestionViewListing = () => {
  const notifi = useRef();
  const [addQuestionData, setAddQuestionData] = useState({
    isOpen: false,
    quizName: '',
    quizId: '',
  });

  const location = useLocation();
  const navigate = useNavigate();

  const queryParams = new URLSearchParams(location.search);

  const quizId = queryParams.get('id');
  const quiz = location?.state || {};
  // const quizId = "bTX76YGxsbiqgY13dkKG";
  const [questionList, setQuestionList] = useState([]);
  const [deletingQuestionId, setDeletingQuestionId] = useState(null);

  const getQuizQuestions = async (quizId) => {
    try {


      console.log('quizId', quizId);

      const quizDocRef = db.collection(`QuizTest/${quizId}/QuationCollection`);
      const quizSnapshot = await quizDocRef.get();

      if (quizSnapshot.empty) {
        return [];
      }

      const questionIds = quizSnapshot.docs.map(
        (doc) => doc.data().QuationsV2Id
      );
      const questionsPromises = questionIds.map(async (qId) => {
        const questionRef = db.collection('QuestionsV2').doc(qId);
        const questionDoc = await questionRef.get();
        return questionDoc.exists
          ? { id: questionDoc.id, ...questionDoc.data() }
          : null;
      });

      const questions = await Promise.all(questionsPromises);
      return questions.filter((q) => q !== null);
    } catch (error) {
      return [];
    }
  };

  const notify = (msg, err) => {
    let color = err === false ? 'success' : 'danger';
    let options = {
      type: color,
      place: 'tr',
      message: (
        <div>
          <div>
            <b>{err === false ? 'Success' : 'Error'}</b> - {msg}.
          </div>
        </div>
      ),
      icon: 'tim-icons icon-bell-55',
      autoDismiss: 6,
    };
    if (notifi.current) {
      notifi.current.notificationAlert(options);
    }
  };

  const QuizQuestionDeleteHandler = async (questionId) => {
    try {
      setDeletingQuestionId(questionId);
      const quizRef = db.collection('QuizTest').doc(quizId);

      // Remove questionId from quizQuestions array
      await quizRef.update({
        quizQuestions: firebase.firestore.FieldValue.arrayRemove(questionId),
      });

      console.log(`Question ID ${questionId} removed from quizQuestions array`);

      // Query QuationCollection for a document with QuationsV2Id == questionId
      const querySnapshot = await db
        .collection('QuizTest')
        .doc(quizId)
        .collection('QuationCollection')
        .where('QuationsV2Id', '==', questionId)
        .get();

      if (!querySnapshot.empty) {
        querySnapshot.forEach(async (doc) => {
          await doc.ref.delete();
          console.log(`Deleted question document with ID: ${doc.id}`);
        });
        fetchQuestion();
        notify('Question deleted successfully', false);
        // getQuizQuestions(quizId)
      } else {
        fetchQuestion();
        notify('Question deleted successfully', false);
        console.log('No matching document found in QuationCollection.');
      }
    } catch (error) {
      console.error('Error deleting question:', error);
      notify('Error deleting question', true);
    } finally {
      setDeletingQuestionId(null);
    }
  };

  const fetchQuestion = ()=>{
    try {
      getQuizQuestions(quizId).then((data) => {
        const formattedQuestions = data
          .map((item) => {
            console.log(item);
            let question = item[item.primaryLanguage] || {};
            let [optionA, optionB, optionC, optionD] = question?.options || [];
            return {
              id: item?.id,
              subject: item?.subject,
              topic: item?.topic,
              questionNumber: item?.questionNumber,
              question: question?.question || 'No question available',
              correctOption: question?.correctOption || 'Not provided',
              optionA: optionA || 'N/A',
              optionB: optionB || 'N/A',
              optionC: optionC || 'N/A',
              optionD: optionD || 'N/A',
            };
          })
          .filter(Boolean);
        console.log(formattedQuestions, 'formattedQuestions');
        setQuestionList(formattedQuestions);
      });
    } catch (error) {
      console.log(error);
    }
  }
  useEffect(() => {
    fetchQuestion()
  }, [quizId]);

  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction='up' ref={ref} {...props} />;
  });

  return (
    <div className='content'>
      <NotificationAlert ref={notifi} />
      <Row>
        <Col md='12'>
          <Card>
            <CardBody>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: '12px',
                }}
              >
                <button
                  onClick={() => navigate('/admin/quiz',{state:{redirect:'quiz'}})}
                  style={{
                    marginRight: '5px',
                    color: 'white',
                    border: '0',
                    padding: '0 ',
                    outline: 'none',
                    background: 'transparent',
                    cursor: 'pointer',
                  }}
                >
                  <KeyboardBackspaceIcon />
                </button>
                <h4 style={{ margin: '0' }}>{quiz?.quizName}</h4>

                <Button
                  onClick={() =>
                    setAddQuestionData({
                      isOpen: true,
                      quizName: quiz?.quizName,
                      quizId: quizId,
                    })
                  }
                  variants='primary'
                  style={{ display: 'block', marginLeft: 'auto' }}
                >
                  Add Question
                </Button>
              </div>

              <Table className='tablesorter' bordered responsive>
                <thead className='text-primary text-center'>
                  <tr>
                    <th>#</th>
                    <th>Question</th>
                    <th>Subject</th>
                    <th>Topic</th>
                    <th>Option A</th>
                    <th>Option B</th>
                    <th>Option C</th>
                    <th>Option D</th>
                    <th>Correct Answer</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {questionList.length > 0 ? (
                    questionList.map((row, index) => (
                      <tr key={row.id} className='text-center'>
                        <td>{index + 1}</td>
                        <td className={row?.subject == 'fganh' || row?.subject == 'हिंदी' ? 'hinditext':''}>{row.question}</td>
                        <td>{row.subject}</td>
                        <td className={row?.subject == 'fganh' || row?.subject == 'हिंदी' ? 'hinditext':''}>{row.topic}</td>
                        <td className={row?.subject == 'fganh' || row?.subject == 'हिंदी' ? 'hinditext':''}>{row.optionA}</td>
                        <td className={row?.subject == 'fganh' || row?.subject == 'हिंदी' ? 'hinditext':''}>{row.optionB}</td>
                        <td className={row?.subject == 'fganh' || row?.subject == 'हिंदी' ? 'hinditext':''}>{row.optionC}</td>
                        <td className={row?.subject == 'fganh' || row?.subject == 'हिंदी' ? 'hinditext':''}>{row.optionD}</td>
                        <td className={row?.subject == 'fganh' || row?.subject == 'हिंदी' ? 'hinditext':''}>{row.correctOption}</td>
                        <td style={{ textAlign: 'center' }}>
                          {deletingQuestionId === row.id ? (
                            <CircularProgress size={20} style={{ color: 'red' }} />
                          ) : (
                            <Delete
                              style={{ color: 'red', cursor: 'pointer' }}
                              fontSize='small'
                              onClick={() => {
                                QuizQuestionDeleteHandler(row.id);
                              }}
                            />
                          )}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={8} className='text-center font-weight-bold'>
                        No questions available.
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </CardBody>
          </Card>
        </Col>
      </Row>

      {addQuestionData?.isOpen && (
        <Dialog
          fullScreen
          open={addQuestionData?.isOpen}
          onClose={() =>
            setAddQuestionData({ isOpen: false, quizName: '', quizId: '' })
          }
          TransitionComponent={Transition}
        >
          <AddQuestionQuiz
            quizDetails={addQuestionData}
            handleClose={() =>{
              fetchQuestion()
              setAddQuestionData({ isOpen: false, quizName: '', quizId: '' })
            }}
          />
        </Dialog>
      )}
    </div>
  );
};

export default QuizQuestionViewListing;
